"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExternalLink = void 0;

/**
 * Check if link is external to provided urls
 * @param {string} link
 * @param {Array<string>} urls
 * @return {boolean}
 */
// eslint-disable-next-line import/prefer-default-export
var isExternalLink = (link, urls) => {
  try {
    // By passing the baseURI as a second parameter, we let the browser map relative
    // URLs into absolute URLs
    var baseURL = new URL(document.baseURI);
    var {
      hostname: linkHost,
      pathname: linkPath
    } = new URL(link, baseURL.origin); // Check if any of the URLs match a known internal URL. If we find a matching
    // internal URL, we should return false (negate the result) because we're checking
    // if its an external link

    return !urls.some(internalUrl => {
      var {
        hostname: internalHost,
        pathname: internalPath
      } = new URL(internalUrl);
      var internalEventCode = internalPath.split('/')[1] || ''; // If the domain doesn't match, this isn't an internal URL

      if (linkHost.toLowerCase() !== internalHost.toLowerCase()) {
        return false;
      } // If the event code matches, this is an internal URL


      var potentialEventCode = linkPath.split('/')[1];
      return potentialEventCode.toLowerCase() === internalEventCode.toLowerCase();
    });
  } catch (_unused) {
    // If something failed when parsing the URL, treat it as an external URL
    return true;
  }
};

exports.isExternalLink = isExternalLink;